export const clearAzureData = async () => {
  sessionStorage.clear()
  const cookies = document?.cookie?.split(';')
  for (let i = 0; i < cookies?.length; ++i) {
    const myCookie = cookies[i]
    const pos = myCookie.indexOf('=')
    const name = pos > -1 ? myCookie.substr(0, pos) : myCookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}
